import { render, staticRenderFns } from "./AgendaStudent.vue?vue&type=template&id=76cdf721"
import script from "./AgendaStudent.vue?vue&type=script&lang=js"
export * from "./AgendaStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports